import {React,useState} from "react";
import { Form, Input, Button, Row, Col } from "antd";
import { useNavigate } from "react-router-dom";

function LandingZoneForm() {
    const [form] = Form.useForm();

    const [state, setState] = useState({
        loggingaccountemail: "",
        loggingaccountname: "",
        securityaccountemail: "",
        securityaccountname: "",
      });
      
      const handleInputChange = (event) => {
        const { name, value } = event.target;
        setState((prevProps) => ({
          ...prevProps,
          [name]: value,
        }));
      };

      const handleSubmit = (event) => {
        event.preventDefault();
        console.log(state);
      };

      const navigate = useNavigate();

      function HandleOpen() {
        navigate("/landingzone");
    }

    const HandleSave = () => {
        form.validateFields().then(() => {
          navigate("/landingzoneformpage");
        }).catch((errorInfo) => {
          console.log("Form validation failed:", errorInfo);
        });
      };

        // function HandleSave() {
        //     navigate("/landingzoneformpage");}
    
    return(
        <>
        <Form onSubmit={handleSubmit} form={form}>
<div className="landingzoneadd">
    <Row gutter={[16, 16]} className="d-flex justify-content-center">
      <Col xxl={18} xl={18} lg={18} md={18} sm={24}>
        <Row gutter={[16, 16]}>
          <Col xxl={5} xl={5} lg={5} md={5} sm={24}>
            <span className="devops-form-names1">Logging AccountEmail</span>
          </Col>
          <Col xxl={1} xl={1} lg={1} md={1} sm={1}></Col>
          <Col xxl={18} xl={18} lg={18} md={18} sm={24}>
            <Form.Item
              name="cloud_platform"
              rules={[{ required: true, message: "Required" }]}
            >
            <Input type="text" className="devops-antd-select" placeholder="Enter logging accountemail" value={state.loggingaccountemail} onChange={handleInputChange}/>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col xxl={5} xl={5} lg={5} md={5} sm={24}>
            <span className="devops-form-names1">Logging AccountName</span>
          </Col>
          <Col xxl={1} xl={1} lg={1} md={1} sm={1}></Col>
          <Col xxl={18} xl={18} lg={18} md={18} sm={24}>
            <Form.Item
              name="account_name"
              rules={[{ required: true, message: "Required" }]}
            >
            <Input type="text" className="devops-antd-select" placeholder="Enter Logging accountname" value={state.securityaccountemail} onChange={handleInputChange}/>
      
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col xxl={6} xl={6} lg={6} md={6} sm={24}>
            <span className="devops-form-names1">
            Security AccountEmail
            </span>
          </Col>
          <Col xxl={18} xl={18} lg={18} md={18} sm={24}>
            <Form.Item
              name="service_name"
              rules={[{ required: true, message: "Required" }]}
            >
<Input type="text" className="devops-antd-select" placeholder="Enter Security AccountEmail" value={state.securityaccountname} onChange={handleInputChange}/>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col xxl={5} xl={5} lg={5} md={5} sm={24}>
            <span className="devops-form-names1">
            Security AccountName
            </span>
          </Col>
          <Col xxl={1} xl={1} lg={1} md={1} sm={1}></Col>
          <Col xxl={18} xl={18} lg={18} md={18} sm={24}>
            <Form.Item
              name="securityaccountname"
              rules={[{ required: true, message: "Required" }]}
            >
            <Input type="text" className="devops-antd-select" 
            placeholder="Enter Security AccountName" 
            value={state.securityaccountname} onChange={handleInputChange}/>
            </Form.Item>
          </Col>
        </Row>
      </Col>
    </Row>
  </div>
  <br />
  <div className="SaveBack">
  <Row gutter={[16, 16]} justify="end">
    <Col span={24}>
      <Form.Item style={{ textAlign: "right" }}>
        <Button
          className="form-back-button"
          htmlType="button"
          onClick={HandleOpen}

        >
          Back
        </Button>
        <Button
          type="primary"
          htmlType="submit"
          className="form-button save-form-button"
          onClick={HandleSave}
        >
          Save
        </Button>
        </Form.Item>
      </Col>
    </Row>
    </div>
  </Form>
  </>

    )}


export default LandingZoneForm;